import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-license-list',
  templateUrl: './license-list.component.html',
  styleUrls: ['./license-list.component.css']
})
export class LicenseListComponent implements OnInit {

  @Input() adminUsers;
  @Output() activeAction = new EventEmitter();
  @Output() blockAction = new EventEmitter();

  constructor() { }


  ngOnInit() {
  }

  onActive(data) {
    this.activeAction.emit(data);

  }

  onBlock(data) {
    this.blockAction.emit(data);

  }

}
